import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
  if (key == "user") state.isAuthenticated = true;
  //state.role = data.role;
};

const setFailure = (state) => {
  state.isLoading = false;
  state.isAuthenticated = false;
};

const userSlice = createSlice({
  name: "user",
  //role: "",
  initialState: {
    isLoading: false,
    isAuthenticated: false,
    user: {},
    userList: [],
    adminList: [],
    updateUser:{},
    adminTasks: [],
  },
  reducers: {
    // login
    loginRequest: (state) => setLoading(state, true),
    loginSuccess: (state, action) =>
      setSuccessWithData(state, action.payload.data.user, "user"),
    loginFailure: (state, action) => {
      setLoading(state, false);
     // state.error = action.payload?.error || "Login failed"; // Store error message
    },

    // logout
logoutRequest: (state) => setLoading(state, true),
logoutSuccess: (state) => setSuccessWithData(state, null, "user"), // Clears user data
logoutFailure: (state) => setLoading(state, false),

    //signup
    signupRequest: (state) => setLoading(state, true),
    signupSuccess: (state) => setLoading(state, false),
    signupFailure: (state) => setLoading(state, false),

    // forgot password
    forgotPasswordRequest: (state) => setLoading(state, true),
    forgotPasswordSuccess: (state) => setLoading(state, false),
    forgotPasswordFailure: (state) => setLoading(state, false),

    // reset password
    verifyOTPRequest: (state) => setLoading(state, true),
    verifyOTPSuccess: (state) => setLoading(state, false),
    verifyOTPFailure: (state) => setLoading(state, false),

    // reset password
    resetPasswordRequest: (state) => setLoading(state, true),
    resetPasswordSuccess: (state) => setLoading(state, false),
    resetPasswordFailure: (state) => setLoading(state, false),


     // get user Profile
     getUserProfileRequest: (state) => setLoading(state, true),
     getUserProfileSuccess: (state, action) =>
       setSuccessWithData(state, action.payload, "userProfile"),
     getUserProfileFailure: (state) => setLoading(state, false),
    // get userList
    getUserListRequest: (state) => setLoading(state, true),
    getUserListSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "userList"),
    getUserListFailure: (state) => setLoading(state, false),



    // get adminList
    getAdminListRequest: (state) => setLoading(state, true),
    getAdminListSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "adminList"),
    getAdminListFailure: (state) => setLoading(state, false),

    // get admin Task Lists
    getAdminTasksListRequest: (state) => setLoading(state, true),
    getAdminTasksListSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "adminTasks"),
    getAdminTasksListFailure: (state) => setLoading(state, false),

    // update user
    updateUserRequest: (state) => setLoading(state, true),
    updateUserSuccess: (state, action) => 
      setSuccessWithData(state, action.payload, "updateUser"),
    updateUserFailure: (state) => setFailure(state),

    // logout User
    logoutUser: (state) => {
      state.isLoading = false;
      state.user = {};
      state.userList = [];
    },
  },
});

export const {
  loginRequest,
  loginSuccess,
  loginFailure,
  logoutRequest,
  logoutSuccess,
  logoutFailure,
  signupRequest,
  signupSuccess,
  signupFailure,
  forgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  verifyOTPRequest,
  verifyOTPSuccess,
  verifyOTPFailure,
  resetPasswordRequest,
  resetPasswordSuccess,
  resetPasswordFailure,
  logoutUser,
  getUserListRequest,
  getUserListSuccess,
  getUserListFailure,
  getUserProfileFailure,
  getUserProfileRequest,
  getUserProfileSuccess,
  getAdminListSuccess,
  getAdminListRequest,
  getAdminListFailure,
  getAdminTasksListRequest,
  getAdminTasksListSuccess,
  getAdminTasksListFailure,
  updateUserRequest,
  updateUserSuccess,
  updateUserFailure,
} = userSlice.actions;

export const userReducerSlice = userSlice.reducer;
